import React from "react";
import "./Surrounding.scss";
import aeon from "../../Media/Fasilitas/Fasilitas (1).webp";
import prasmul from "../../Media/Fasilitas/Fasilitas (2).webp";
import binus from "../../Media/Fasilitas/Fasilitas (3).webp";
import breeze from "../../Media/Fasilitas/Fasilitas (4).webp";
import qbig from "../../Media/Fasilitas/Fasilitas (5).webp";
import eka from "../../Media/Fasilitas/Fasilitas (6).webp";
import tol from "../../Media/Fasilitas/Fasilitas (7).webp";
import sekolah from "../../Media/Fasilitas/Fasilitas (8).webp";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const Surrounding = () => {
  const slides = [
    {src: aeon, des: "Main Gate"},
    {src: prasmul, des: "Club House"},
    {src: binus, des: "Swimming Pool"},
    {src: breeze, des: "Tennis & Basketball Court"},
    {src: qbig, des: "Reflection Pool"},
    {src: eka, des: "Community Garden"},
    {src: tol, des: "BBQ Pavilion"},
    {src: sekolah, des: "Playground"},
  ];
  const settings = {
    dots: true,
    infinite: true,
    autoplay: false,
    lazyLoad: true,
    speed: 500,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <div id="fasilitas" className="surroundingcontainer">
      <div className="title">Premium Facillities</div>
      <div className="content">
        {slides.map((slide, index) => (
          <div className="center" key={index}>
            <img className="imgcontent" src={slide.src} alt="Surrounding" />
            <div className="imgdes">
              <span>{slide.des}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="content1">
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <div className="center" key={index}>
              <img className="imgcontent" src={slide.src} alt="Surrounding" />
              <div className="imgdes">
                <span>{slide.des}</span>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Surrounding;
